<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
/* 添加一些全局样式 */
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
}
.container {
    width: 80%;
    margin: 0 auto;
}
</style>